document.addEventListener('DOMContentLoaded', function() {
    // move the tree planted div
    const moveTreePlantedDiv = () => {
        const treePlantedDiv = document.querySelector('.cart-flyout-item.one-tree-planted.item-cart-one-tree-planted');
        const cartContainer = document.querySelector('.product-list');

        if (treePlantedDiv && cartContainer) {
            cartContainer.appendChild(treePlantedDiv);
            return true;
        }
        return false;
    };

    // Try immediately first
    if (!moveTreePlantedDiv()) {
        // If not successful, observe only the cart container area
        const observer = new MutationObserver((mutationsList) => {
            if (moveTreePlantedDiv()) {
                observer.disconnect(); // Stop observing once successful
            }
        });

        // Only observe the cart area instead of the entire body
        const cartArea = document.querySelector('#CartFlyout');
        if (cartArea) {
            observer.observe(cartArea, { childList: true, subtree: true });
            // Set a timeout to stop observing after 10 seconds to prevent endless observation
            setTimeout(() => observer.disconnect(), 10000);
        }
    }
});
